const pickExerciseAtCursor = (list, cursor) => {
  if (!Array.isArray(list) || list.length === 0) {
    return null;
  }

  if (typeof cursor === 'number' && cursor >= 0 && cursor < list.length) {
    return list[cursor];
  }

  return list[0];
};

export default pickExerciseAtCursor;
